import { render, staticRenderFns } from "./salary-tpl-dialog.vue?vue&type=template&id=1a7bfe59&scoped=true"
import script from "./salary-tpl-dialog.vue?vue&type=script&lang=js"
export * from "./salary-tpl-dialog.vue?vue&type=script&lang=js"
import style0 from "./salary-tpl-dialog.vue?vue&type=style&index=0&id=1a7bfe59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7bfe59",
  null
  
)

export default component.exports